var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask",on:{"click":_vm.handleClose}},[_c('div',{staticClass:"modal-wrapper"},[(_vm.modalData.component)?_c('div',{staticClass:"modal-if"},[_c(_vm.modalData.component,{tag:"component",attrs:{"modalData":_vm.modalData}})],1):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }